var utils = require('./utils')
var mods = require('./mods')

module.exports = {

    /**
     *  支付宝h5浏览器打开
     * @param {Object} payment 
     */
    wapFunc: function (payment) {
        // 如果是 prod_mode 模式打开的url则是用测试页拼接的连接 否则是正常连接
        let url = payment.prod_mode === "false" ? payment.expend.pay_info + "?payment_id=" + payment.id + "&pay_channel=" + payment.pay_channel : payment.expend.pay_info
        // 在支付链接前拼接支付宝的 scheme 文档见：https://myjsapi.alipay.com/jsapi/h5app-lifecycle.html

        // "alipays://platformapi/startapp?appId=20000067&url=" + url  是为了保证打开支付宝app的时候不会跳转到支付宝页面，以至于轮询拿不到结果。
        // utils.os.isPc ? window.open(url) : window.location.href = "alipays://platformapi/startapp?appId=20000067&url=" + url
        // window.location.href = "alipays://platformapi/startapp?appId=20000067&url=" + url
        
        // alipays://platformapi/startapp?saId=10000007&qrcode=
        // alipays://platformapi/startapp?appId=10000007&qrcode=
        window.location.href = "alipays://platformapi/startapp?saId=10000007&qrcode=" + url;
    },

    /**
     *  支付宝小程序或者支付宝内部 H5
     * @param {String} tradeNO 
     * @param {*} callback 
     */
    liteFunc: function (tradeNO, callback) {
        self = this;

        if (typeof AlipayJSBridge !== "undefined") {
            AlipayJSBridge.call("tradePay", {
                tradeNO: tradeNO, // 必传，此使用方式下该字段必传
            }, function(result) {
                callback(result)
            });
        }else if (typeof this.ap !== "undefined") {
            this.ap.tradePay({
                tradeNO: tradeNO
            }, function(result){
                callback(result)
            });
        }else{
            self.loadAlipay().then(res => {
                if (res) {
                    self.liteFunc()
                }
            }).catch(err => {
                console.error(err)
            })
        }
    },

    /**
     *  加载 支付宝 的CDN
     */
    loadAlipay: function () {
        return new Promise((resolve, reject) => {
            let script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.0.0/alipayjsapi.inc.min.js";
            script.onload = () => {  
                resolve(true)
            }
            script.onerror = reject;
            document.head.appendChild(script);
            
        })
    },

    /**
     *  轮询支付结果
     */
    handlePayResult: function () {
        return new Promise((resolve, reject) => {
            setTimeout(function () {
                resolve('支付成功')
            }, 5000)
        })
    }
}


// WEBPACK FOOTER //
// ./src/aliPay.js